import { render, staticRenderFns } from "./PageLives.vue?vue&type=template&id=2de9a742&scoped=true&"
import script from "./PageLives.vue?vue&type=script&lang=ts&"
export * from "./PageLives.vue?vue&type=script&lang=ts&"
import style0 from "./PageLives.vue?vue&type=style&index=0&id=2de9a742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9a742",
  null
  
)

export default component.exports